import React, { PureComponent, Component } from 'react';
import TableRowLink from './TableRowLink'

class TableRow extends PureComponent {
    constructor(props) {
        super(props)
        this.routeToEditarConfiguracionProceso = this.routeToEditarConfiguracionProceso.bind(this);
        }

componentDidMount(){
    $('[data-toggle="tooltip"]').tooltip();
}

routeToEditarConfiguracionProceso() {
        this.props.routeToEditarConfiguracionProceso(this.props.procesos.ProcesoId);
}

    render() {
        const { procesos, esPar } = this.props;
        let backColor = (esPar ? 'seccionGrilla__registro--registroGris' : 'white')

        let inconoTipo, nombreIcono;
        switch (procesos.TipoProceso) {
            case 'I':
                inconoTipo = 'icono-input3'
                nombreIcono = 'Archivo Input'
                break;
            case 'O':
                inconoTipo = 'icono-output3'
                nombreIcono = 'Archivo Output'
                break;
            case 'P':
                inconoTipo = 'icono-gear3'
                nombreIcono = 'Proceso'
                break;
        }


        return (

            <tr className={`seccionGrilla__registro tableroPointer with-hover seleccionPointer ${backColor}`} onClick={this.routeToEditarConfiguracionProceso}>
                <td>
                    <div className={inconoTipo} style={{ marginLeft: "30px", top: "0px" }}></div>
                    <div className='procesoTabText' style={{ marginLeft: "18px" }}>
                        {nombreIcono}
                    </div>
                </td>
                <td>
                    <label className="configuracionProcesosLabel">
                    <TableRowLink Id={procesos.ProcesoId}
                        nombre={procesos.NombreProceso}/>
                    </label>
                </td>
                <td>
                    <label className="configuracionProcesosLabel">{procesos.DescripcionProceso}</label>
                </td>
                <td>
                    <label className="configuracionProcesosLabel">{procesos.Periodicidad}</label>
                </td>
                <td>
                    <label className="configuracionProcesosLabel">
                        {procesos.ProcesamientoParcial ? 'Permitido' : 'No Permitido'}
                    </label>
                </td>
                <td>
                <label className="configuracionProcesosLabel">
                {procesos.EstaActivo != 1 ?
                    <div>
                        <div className="seccionGrilla__registroIconoInactivo" data-toggle="tooltip" data-title="Inactivo" data-placement="left" data-original-title="" title=""></div>
                    </div>
                      
                    : 
                        ""
                }
                </label>
                </td>
                <td>

                </td>
            </tr>
        )
    }
};

export default TableRow;